import { Box, CircularProgress, Paper, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import { BaseButton } from 'components/BaseButton';
import { useNotifications } from './hooks';
import SendMessage from './components/send-notification';
import TableMessage from './components/table-message';
import MessageModal from './components/message-modal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      minWidth: 0,
      padding: theme.spacing(1),
      [theme.breakpoints.up('sm')]: { padding: theme.spacing(3) },
    },
    mainContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minWidth: 0,
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: { padding: theme.spacing(3) },
    },
    header: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) },
    },
    headerTitle: {
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
    stateContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4, 2),
      textAlign: 'center',
    },
  })
);

const Notifications = () => {
  const classes = useStyles();
  const {
    messages,
    isLoading,
    t,
    toggleOpen,
    open,
    notifications,
    parties,
    hanldeSubmitNotification,
    isSending,
    selectedMessage,
    setSelectedMessage,
    closeMessage,
  } = useNotifications();

  const renderContent = () => {
    if (isLoading) {
      return (
        <Box className={classes.stateContainer}>
          <CircularProgress color="secondary" />
        </Box>
      );
    }
    if (messages.length === 0) {
      return (
        <Box className={classes.stateContainer}>
          <Typography variant="body2">{t('messages:no-notifications')}</Typography>
        </Box>
      );
    }
    return <TableMessage t={t} messages={messages} setSelectedMessage={setSelectedMessage} />;
  };

  return (
    <Box className={classes.container}>
      <Paper className={classes.mainContainer}>
        <Box className={classes.header}>
          <Typography variant="h5" component="h1" className={classes.headerTitle}>
            {t('messages:notifications')}
          </Typography>
          <BaseButton icon="paper-plane" text={t('messages:send-new')} onClick={toggleOpen} />
        </Box>
        {renderContent()}
      </Paper>
      {open && (
        <SendMessage
          open={open}
          handleClose={toggleOpen}
          t={t}
          notifications={notifications}
          parties={parties}
          hanldeSubmitNotification={hanldeSubmitNotification}
          isSending={isSending}
        />
      )}
      {selectedMessage && (
        <MessageModal
          open={Boolean(selectedMessage)}
          handleClose={closeMessage}
          t={t}
          message={selectedMessage}
        />
      )}
    </Box>
  );
};

export default Notifications;
